import gql from 'graphql-tag';

const query = gql`
  query PaymentMethods($amount: Float) {
    sale {
      payment {
        methods(amount: $amount) {
          ... on SaleMethod {
            methodId
            channelId
            name
            description
            logoUrl
            wideViewportLogoUrl
          }
        }
      }
    }
  }
`;

export default query;
